'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ToggleSwitch = require('./ToggleSwitch');

Object.defineProperty(exports, 'ToggleSwitch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ToggleSwitch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/toggleSwitch/index.js
// module id = 621
// module chunks = 0